import "./HurrydleTable.css";

// TODO: Fix the set state and render issue....
const HurrydleTable = ({
    wordOfDay, 
    letterArray, 
    hurrydleRows, 
    blankLetters, 
    setBlankLetters,
    yellowLetters, 
    setYellowLetters,
    greenLetters, 
    setGreenLetters,
  }) => {
  return (
    <div className="HurrydleTable">
      <table>
        <tbody className="hurrydle-letters">
          { 
            hurrydleRows.map(hr => hurrydleRow(
              wordOfDay, 
              hr, 
              blankLetters, 
              setBlankLetters,
              yellowLetters, 
              setYellowLetters,
              greenLetters, 
              setGreenLetters,
            )) 
          }
          { hurrydleCurrentRow(letterArray) }
        </tbody>
      </table>
    </div>
  );
}

export default HurrydleTable;

const hurrydleCurrentRow = (letterArray) => {
  return (
    <tr className="hurrydle-current-row">
      <td>{ letterArray[0] }</td>
      <td>{ letterArray[1] }</td>
      <td>{ letterArray[2] }</td>
      <td>{ letterArray[3] }</td>
      <td>{ letterArray[4] }</td>
    </tr>
  );
}

const hurrydleRow = (
  wordOfDay, 
  letterArray,
  blankLetters, 
  setBlankLetters,
  yellowLetters, 
  setYellowLetters,
  greenLetters, 
  setGreenLetters,
) => {
  let foundLetters = [];
  return (
    <tr className="hurrydle-row">
      <td className={checkLetterColor(
        wordOfDay, 
        letterArray, 
        0, 
        foundLetters,
        blankLetters, 
        setBlankLetters,
        yellowLetters, 
        setYellowLetters,
        greenLetters, 
        setGreenLetters,
      )}>{ letterArray[0] }</td>
      <td className={checkLetterColor(
        wordOfDay, 
        letterArray, 
        1, 
        foundLetters,
        blankLetters, 
        setBlankLetters,
        yellowLetters, 
        setYellowLetters,
        greenLetters, 
        setGreenLetters,
      )}>{ letterArray[1] }</td>
      <td className={checkLetterColor(
        wordOfDay, 
        letterArray, 
        2, 
        foundLetters,
        blankLetters, 
        setBlankLetters,
        yellowLetters, 
        setYellowLetters,
        greenLetters, 
        setGreenLetters,
      )}>{ letterArray[2] }</td>
      <td className={checkLetterColor(
        wordOfDay, 
        letterArray, 
        3, 
        foundLetters,
        blankLetters, 
        setBlankLetters,
        yellowLetters, 
        setYellowLetters,
        greenLetters, 
        setGreenLetters,
      )}>{ letterArray[3] }</td>
      <td className={checkLetterColor(
        wordOfDay, 
        letterArray, 
        4, 
        foundLetters,
        blankLetters, 
        setBlankLetters,
        yellowLetters, 
        setYellowLetters,
        greenLetters, 
        setGreenLetters,
      )}>{ letterArray[4] }</td>
    </tr>
  );
}

const checkLetterColor = (
  wordOfDay, 
  letterArray, 
  index, 
  foundLetters,
  blankLetters, 
  setBlankLetters,
  yellowLetters, 
  setYellowLetters,
  greenLetters, 
  setGreenLetters,
) => {
  // Ensure that the number of found letters that match do not exceed actual count
  if (countOccurrences(wordOfDay, letterArray[index]) > countOccurrences(foundLetters, letterArray[index])) {
    if (wordOfDay[index] === letterArray[index]) {
      if (letterDoesNotExistInString(greenLetters, letterArray[index])) {
        let newLetters = greenLetters;
        newLetters = newLetters + letterArray[index] + " ";
        setGreenLetters(newLetters);
      }
      foundLetters.push(letterArray[index]);
      return "hurrydle-green";
    } 
    
    if (wordOfDay.indexOf(letterArray[index]) > -1) {
      
      let greenLetterCount = 0;
      for (let i = 0; i < letterArray.length; i++) {
        if (wordOfDay[i] === letterArray[i] && wordOfDay[i] === letterArray[index]) {
          greenLetterCount++;
        }
      }

      
      const allowedYellowLetterOverage = countOccurrences(wordOfDay, letterArray[index]) - greenLetterCount;
      if (allowedYellowLetterOverage <= 0) {
        // All green letters have been found, no more yellow allowed
        if (letterDoesNotExistInString(blankLetters, letterArray[index])) {
          let newLetters = blankLetters;
          newLetters = newLetters + letterArray[index] + " ";
          setBlankLetters(newLetters);
        }
        return "";
      }

      // We will need to check that there are only appropriate 'yellow' letter candidates if we are accounting for at least some green
      if (greenLetterCount > 0 && allowedYellowLetterOverage > 0) {

        // We will allow the up to the number of redundantLetters found for yellowLetters
        let allowedYellowLetterIndexes = [];
        for (let i = 0; i < letterArray.length; i++) {
          // If this letter is found in the wordOfDay it will be added to array if allowedYellowLetterOverage hasn't been reached
          if ((wordOfDay.indexOf(letterArray[i]) > -1) && allowedYellowLetterIndexes.length <= allowedYellowLetterOverage) {
            allowedYellowLetterIndexes.push(i);
          }
        }
        
        // If this index matches an allowed yellow letter index we will ignore, otherwise return blank
        if (!(allowedYellowLetterIndexes.indexOf(index) > -1)) {
          if (letterDoesNotExistInString(blankLetters, letterArray[index])) {
            let newLetters = blankLetters;
            newLetters = newLetters + letterArray[index] + " ";
            setBlankLetters(newLetters);
          }
          return "";
        }
      }

      // No special cases with this yellow letter, just return yellow
      if (letterDoesNotExistInString(yellowLetters, letterArray[index])) {
        let newLetters = yellowLetters;
        newLetters = newLetters + letterArray[index] + " ";
        setYellowLetters(newLetters);
      }
      foundLetters.push(letterArray[index]);
      return "hurrydle-yellow";
    }
  }
  // Return blank default
  if (letterDoesNotExistInString(blankLetters, letterArray[index])) {
    let newLetters = blankLetters;
    newLetters = newLetters + letterArray[index] + " ";
    setBlankLetters(newLetters);
  }
  return "";
}

const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

const letterDoesNotExistInString = (keyboardString, letter) => {
  if (keyboardString.includes(letter)) {
    return false;
  }
  return true;
}